import { isBefore, isValid, parseISO } from "date-fns";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import {
  fetchTesSalaryTablesByTes,
  TesSalaryTableDocument,
} from "../../../tesSalaryTables/tesSalaryTablesApi";
import {
  BULK_SALARY_INCREASE_FILTER_NAMES,
} from "../constants";
import { BulkSalaryIncreaseFilterValues } from "../types";
import SalaryIncreaseConfigBasic from "./SalaryIncreaseConfigBasic";

/**
 * Salary row date for TES_TABLES bulk flow: same field as other targets, minimum = selected target table effective date.
 */
const BulkSalaryIncreaseTesTablesSalaryDate = () => {
  const { watch, setValue, getValues } =
    useFormContext<BulkSalaryIncreaseFilterValues>();
  const tes = watch(BULK_SALARY_INCREASE_FILTER_NAMES.TES);
  const tesId = tes?.id ?? null;
  const targetId = watch("tesSalaryTableTargetId");
  const [publishedTables, setPublishedTables] = useState<TesSalaryTableDocument[]>(
    [],
  );

  useEffect(() => {
    if (!tesId) {
      setPublishedTables([]);
      return;
    }
    let cancelled = false;
    fetchTesSalaryTablesByTes(tesId, { status: "PUBLISHED" })
      .then((rows) => {
        if (!cancelled) {
          setPublishedTables(rows);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setPublishedTables([]);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [tesId]);

  const targetDoc = publishedTables.find(
    (doc) => doc.tesSalaryTableId === targetId,
  );
  const minDateParsed = targetDoc?.effectiveDate
    ? parseISO(targetDoc.effectiveDate)
    : undefined;
  const minDate =
    minDateParsed && isValid(minDateParsed) ? minDateParsed : undefined;

  useEffect(() => {
    if (!minDate) {
      return;
    }
    const current = getValues(
      BULK_SALARY_INCREASE_FILTER_NAMES.SALARY_INCREASE_START_DATE,
    );
    if (
      !current ||
      !isValid(current) ||
      isBefore(current, minDate)
    ) {
      setValue(
        BULK_SALARY_INCREASE_FILTER_NAMES.SALARY_INCREASE_START_DATE,
        minDate,
      );
    }
  }, [minDate, targetId, getValues, setValue]);

  return <SalaryIncreaseConfigBasic minDate={minDate} />;
};

export default BulkSalaryIncreaseTesTablesSalaryDate;
